var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.getClassObject(),on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":("#B_Brand-icon-" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }